import { render } from "./ApplicationStatus.vue?vue&type=template&id=548b978e&scoped=true"
import script from "./ApplicationStatus.vue?vue&type=script&lang=js"
export * from "./ApplicationStatus.vue?vue&type=script&lang=js"

import "./ApplicationStatus.vue?vue&type=style&index=0&id=548b978e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-548b978e"]])

export default __exports__